// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"18":"product","561":"slideshow"}[chunkId] || chunkId) + "." + {"18":"a77085e5","117":"8811dc16","561":"17b7ea8b"}[chunkId] + ".js";
};